// 生成文献ID的辅助函数
export const generateReferenceId = (title, index = 0) => {
    // 清理标题中的特殊字符，只保留中英文、数字和常见标点
    const cleanTitle = (title || '')
        .replace(/[^\u4e00-\u9fa5a-zA-Z0-9\s\-_.,:;()（）]/g, '')
        .trim()
        .substring(0, 50); // 限制长度

    // 如果标题为空，使用默认名称
    const finalTitle = cleanTitle || '未命名文献';

    // 生成唯一ID：枚举值_标题_索引（如果需要）
    const baseId = `SEARCH_RESULT_${finalTitle}`;
    return index > 0 ? `${baseId}_${index}` : baseId;
};
